import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { ParamOption } from '../../../components/paramOption'
import { PagingContent } from '../../../components/pagingList'
import { NotificationList, NotificationItem } from '../../notification/components/List'

export const Disclosure = observer(() => {
  const {
    commonStore,
    notificationStore: { disclosureStore, disclosureCategoryStore },
  } = useContext(StoresContext)
  const [categoryId, setCategoryId] = useState<number | undefined>(undefined)

  useEffect(() => {
    commonStore.setShowTab(false)
    disclosureCategoryStore.load(undefined, true)
  }, [])

  useEffect(() => {
    // onParams({ categoryId, store: disclosureStore })
    disclosureStore.load({ data: { categoryId } }, true)
  }, [categoryId])

  return (
    <Wrap>
      <Header type="SUB" title="공시" />
      <StyledContent>
        <ParamOption
          categoryData={{
            categoryList: disclosureCategoryStore.list,
            categoryId,
            setCategoryId: (id) => setCategoryId(id === -1 ? undefined : id),
          }}
        />
        <PagingContent
          pagingStore={disclosureStore}
          emptyText="조회 가능한 공시가 없습니다."
          loadParam={{ categoryId }}
        >
          <NotificationList>
            {disclosureStore.list.map(({ id, categoryId, title, createdDate }) => {
              const categoryName = disclosureCategoryStore.list.find((v) => v.id === categoryId)?.name
              return (
                <Link key={id} to={`/disclosure/${id}`}>
                  <NotificationItem>
                    <NotificationItem.Type>{categoryName ?? '공시'}</NotificationItem.Type>
                    <NotificationItem.Title>{title}</NotificationItem.Title>
                    <NotificationItem.Date>{createdDate}</NotificationItem.Date>
                  </NotificationItem>
                </Link>
              )
            })}
          </NotificationList>
        </PagingContent>
      </StyledContent>
    </Wrap>
  )
})

const StyledContent = styled(Content)`
  > div:first-child {
    margin: 16px 0 8px;
  }
`
